import { IDocumentoImportacion } from '../models/iDocumentoImportacion.model';
import { ROUTE_LOGISTICA } from './../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DocImportacionService {


    constructor(
        private apiService: ApiService,
        private http: HttpClient
    ) { }

    insertarDocImportacion(data: IDocumentoImportacion): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudDocImportacion);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarDocImportacion(data: IDocumentoImportacion): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudDocImportacion);
        return this.apiService.executePutJson(data).pipe();
    }

    calcularDocImportacion(data: IDocumentoImportacion): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.calcularDocImportacion);
        return this.apiService.executePutJson(data).pipe();
    }

    buscarDocImportacion(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.buscaDocImportacion);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
    }

    download_pdf(_formato: number, numint: number, cia: string) {
        let fullUrl: any = null;
        if (_formato == 1)
            fullUrl = environment.serviceUrl_Report + `documento-importacion/${numint}/report/public/format-1.pdf?` + "cia=" + cia;
        if (_formato == 2)
            fullUrl = environment.serviceUrl_Report + `documento-importacion/${numint}/report/public/format-2.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }

    reutilizarDocImportacion(serie: number, numdoc: number) {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudDocImportacion);
        return this.apiService.execGetQueryJson(`/${serie}/${numdoc}`).pipe();
    }

    visar(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `documento-importacion/${numint}/visar?` + "coduser=" + coduser, { observe: 'response' });
    }

    anular(numint: number, coduser: string) {//sin descuento
        return this.http.put(environment.serviceUrl + `documento-importacion/${numint}/anular?` + "coduser=" + coduser, { observe: 'response' });
    }


    obtenerDocImp(numint: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudDocImportacion);
        return this.apiService.execGetQueryJson(`/${numint}`).pipe();
    }

    downloadExcelComercialResportesDocumentoImportacion(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi('consultas/docu-importacion');
        return this.apiService.execGetQueryJsonPDF(`/excel.xlsx?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
    }

    importarExcel(parameters: any): Observable<any> {
        let formData: FormData = new FormData();

        formData.append('file', parameters.file);
        formData.append('ruc', parameters.ruc);
        formData.append('razonc', parameters.razonc);
        formData.append('nombrearchivo', parameters.nombrearchivo);

        this.apiService.setUrlPathApi(`importaExcel/`);

        // return this.http.post(environment.serviceUrl + "importaExcel/articulos", formData);

        // return this.apiService.execGetQueryJsonObjectPDF(`doc-importacion`, formData).pipe();
        return this.http.post(environment.serviceUrl + "importaExcel/doc-importacion", formData, { observe: 'response' });
    }

    exportarFormatoExcel(numints: string) {

        let vParams = "";
        if (numints != undefined && numints != null && numints != "") {
            vParams = "?numints=" + numints;
        }

        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(environment.serviceUrl + "exportacionFormato/doc-importacion/excel" + vParams, httpOptions);
    }


}
